<template>
  <div
    class="nav-bar"
    :class="{ 'nav-section-scrolling': showMenuBg > 80 || mobileMenuStatus }"
  >
    <nav class="content">
      <div class="site-logo">
        <router-link
          to="/"
          class="site-logo"
          active-class="active"
          @click.native="goToPage"
          ><img src="../assets/logo.png"
        /></router-link>
      </div>
      <div class="nav-btn" @click="toggleMenu()">
        <img src="../assets/menu-btn.svg" alt="Menu Button" />
      </div>
      <div class="menu-links" :class="mobileMenuStatus ? 'show' : 'collapsed'">
        <!-- <router-link
          to="/pages/about"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.about") }}</router-link
        >
        <router-link
          to="/pages/traffic-mining"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.traffic") }}</router-link
        >
        <router-link
          to="/pages/gsg-gema"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.gsg-gema") }}</router-link
        > -->
        <router-link
          to="/pages/nft-gsg"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.nft") }}</router-link
        >
        <router-link
          to="/pages/team"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.team") }}</router-link
        >
        <router-link
          to="/pages/contact"
          class="nav-link"
          active-class="active"
          @click.native="goToPage"
          >{{ $t("nav.contact") }}</router-link
        >
        <router-link
          to="/login"
          class="login-btn"
          @click.native="goToPage"
          >{{ $t("nav.login") }}</router-link
        >
        <button @click="switchLang()" class="btn btn-sm btn-info text-white">
          {{ $i18n.locale === "en" ? "中文" : "English" }}
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      mobileMenuStatus: false,
      showMenuBg: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    switchLang() {
      this.mobileMenuStatus = false;
      if (this.$i18n.locale === "en") {
        this.$i18n.locale = "cn";
      } else {
        this.$i18n.locale = "en";
      }
    },
    toggleMenu() {
      this.mobileMenuStatus = !this.mobileMenuStatus;
    },
    handleScroll() {
      this.showMenuBg = window.scrollY;
    },
    goToPage() {
      this.mobileMenuStatus = false;
      window.scrollTo(0, 0);
    }
  },
};
</script>

<style scoped>
.nav-bar {
  height: 80px;
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  transition: all 0.3s ease-out;
}
.nav-bar.nav-section-scrolling {
  background-color: white;
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.3);
  z-index: 999;
}
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  a,
  a:visited {
    text-decoration: none;
    color: #3b3e51;
  }
  a:hover,
  a.nav-link.active {
    color: #0a58ca;
  }
  .site-logo img {
    max-height: 40px;
  }
  .menu-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 70px;
    left: 0;
    gap: 1rem;
    width: 100%;
    background-color: white;
    padding: 1rem;
    box-sizing: border-box;
    transition: all 0.3s ease-out;
    .login-btn {
      background-color: #ef8200;
      color: white;
      height: 26px;
      padding: 0.1rem 1.5rem;
      display: inline-flex;
      align-items: center;
      border-radius: 1rem;
      margin-left: 0.8rem;
    }
  }
  .menu-links.collapsed {
    visibility: hidden;
    opacity: 50;
    height: 0;
    overflow: hidden;
    z-index: -1;
  }
  .menu-links.show {
    visibility: visible;
    opacity: 100;
    height: 23rem;
    z-index: 999;
    box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.3);
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .nav-bar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a,
    a:visited {
      text-decoration: none;
      color: #3b3e51;
    }
    a:hover,
    a.nav-link.active {
      color: #0a58ca;
    }
    .menu-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      .login-btn {
        background-color: #ef8200;
        color: white;
        height: 26px;
        padding: 0.1rem 1.5rem;
        display: inline-flex;
        align-items: center;
        border-radius: 1rem;
        margin-left: 0.8rem;
      }
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .nav-bar {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a,
    a:visited {
      text-decoration: none;
      color: #3b3e51;
    }
    a:hover,
    a.nav-link.active {
      color: #0a58ca;
    }
    .site-logo img {
      max-height: auto;
    }
    .menu-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      .login-btn {
        background-color: #ef8200;
        color: white;
        height: 26px;
        padding: 0.1rem 1.5rem;
        display: inline-flex;
        align-items: center;
        border-radius: 1rem;
        margin-left: 0.8rem;
      }
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .nav-bar {
    padding: 0;
    background: linear-gradient(
      180deg,
      #ffffff 65%,
      rgba(255, 255, 255, 0) 100%
    );
    position: relative;
  }
  .nav-bar.nav-section-scrolling {
    background-color: linear-gradient(
      180deg,
      #ffffff 65%,
      rgba(255, 255, 255, 0) 100%
    );
    box-shadow: none;
  }
  nav {
    .menu-links {
      flex-direction: row;
      position: relative;
      background-color: transparent;
      padding: 0;
      position: relative;
      top: 0;
      width: auto;
    }
    .nav-btn {
      display: none;
    }
    .menu-links.collapsed,
    .menu-links.show {
      visibility: visible;
      opacity: 100;
      height: auto;
      z-index: 999;
      box-shadow: none;
    }
  }
}
</style>
